import { useState, useEffect, useCallback } from 'react';
import { useDubs } from '../provider';
import type { UFCFighterDetail, QueryResult } from '../types';

export function useUFCFighterDetail(athleteId: string | null): QueryResult<UFCFighterDetail> {
  const { client } = useDubs();
  const [data, setData] = useState<UFCFighterDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    if (!athleteId) {
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await client.getUFCFighterDetail(athleteId);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, [client, athleteId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
